export default () => ({
  1553697337596: {
    id: 1553697337596,
    titulo: 'Verificação',
    perguntas: {
      1553697343865: {
        id: 1553697343865,
        titulo: 'Atendeu a notificação?',
        tipo: 'sim_nao',
        obrigatorio: true,
        min_fotos: 2,
      },
      1553697360395: {
        id: 1553697360395,
        titulo: 'Autuar?',
        tipo: 'sim_nao',
        obrigatorio: true,
        min_fotos: 2,
        acoes: [{ op: { eq: true }, run: ['notificacao.autuar'] }],
        condicao: {
          grupo_id: 1553697337596,
          pergunta_id: 1553697343865,
          operacao: 'eq',
          resposta: false,
        },
      },
      1553697386426: {
        id: 1553697386426,
        titulo: 'Emitir reincidência?',
        tipo: 'sim_nao',
        obrigatorio: true,
        min_fotos: 2,
        acoes: [
          { op: { eq: true }, run: ['notificacao.aplicar_reincidencia'] },
        ],
        condicao: {
          grupo_id: 1553697337596,
          pergunta_id: 1553697360395,
          operacao: 'eq',
          resposta: true,
        },
      },
      1553697435614: {
        id: 1553697435614,
        titulo: 'Justifique',
        tipo: 'text',
        obrigatorio: true,
        min_fotos: 2,
        condicao: {
          grupo_id: 1553697337596,
          pergunta_id: 1553697360395,
          operacao: 'eq',
          resposta: false,
        },
        acoes: [{ op: { not_empty: null }, run: ['notificacao.comentar'] }],
      },
      1553697461465: {
        id: 1553697461465,
        titulo: 'Justifique',
        tipo: 'text',
        obrigatorio: true,
        min_fotos: 2,
        condicao: {
          grupo_id: 1553697337596,
          pergunta_id: 1553697386426,
          operacao: 'eq',
          resposta: false,
        },
        acoes: [{ op: { not_empty: null }, run: ['notificacao.comentar'] }],
      },
    },
  },
})
